/**
 * @desc 根据sku编号查询sku包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuWarehousePackageRpcResponseDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuWarehousePackage/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
